import { render, staticRenderFns } from "./SetRemindModal.vue?vue&type=template&id=431f7235&scoped=true"
import script from "./SetRemindModal.vue?vue&type=script&lang=js"
export * from "./SetRemindModal.vue?vue&type=script&lang=js"
import style0 from "./SetRemindModal.vue?vue&type=style&index=0&id=431f7235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f7235",
  null
  
)

export default component.exports